import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { logDebug } from "../lib/log";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const SiteCtx = createContext(null);

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);
  useEffect(() => {
    api.get("/site").then((r) => setSite(r.data)).catch((e) => logDebug("site load failed", e));
  }, []);
  return <SiteCtx.Provider value={site}>{children}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);

// Returns the dashboard-managed image URL for a slot, or the static fallback.
export const siteImg = (site, slot, fallback) => {
  const v = site?.images?.[slot];
  if (!v) return fallback;
  return v.startsWith("http") ? v : `${BACKEND}${v}`;
};
